'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('HubStyleTokens/colors');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledBlob = _styledComponents2.default.div.withConfig({
  displayName: 'StyledBlob'
})(['background-color:', ';height:458px;z-index:-1;border-bottom-left-radius:100%;border-bottom-right-radius:100%;'], _colors.GYPSUM);

exports.default = StyledBlob;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/StyledBlob.js
// module id = 216
// module chunks = 3 4